
































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import formRules from "@/helpers/formRules";

@Component({
  components: {}
})
export default class PaymentMethod extends Vue {
  radios = "radio-1";
  radioColor = "#BA324F";
  formValid = false;
  myRules = {
    name: formRules.nameRules,
    number: formRules.mandatoryCreditCard,
    expiryDate: formRules.mandatoryField,
    digits: formRules.mandatoryField
  };

  @Watch("formValid")
  onValidationChanged(val: boolean) {
    this.$emit("formValid", this.formValid);
  }

  mounted() {}
}
